import { render } from "./IconFunClutch.vue?vue&type=template&id=5e43b0fc&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconFunClutch.vue?vue&type=script&lang=js"
export * from "./IconFunClutch.vue?vue&type=script&lang=js"
script.render = render

export default script